"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  /*'/branches': {
  	title: 'Branches',
  	view: 'Branches',
  	public: true,
  	locales: {
  		az: '/az/branches',
  		en: '/en/branches',
  		ru: '/ru/branches',
  	}
  },
  '/az/branches': {ref: '/branches', lang: 'az', title: 'Branches'},
  '/en/branches': {ref: '/branches', lang: 'en', title: 'Branches'},
  '/ru/branches': {ref: '/branches', lang: 'ru', title: 'Branches'},*/
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vbGlicmFyeS9zcmMvY2xpZW50L21vZHVsZXMvQ29udGVudC9CcmFuY2gvQnJhbmNoUm91dGVzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcclxuXHQvKicvYnJhbmNoZXMnOiB7XHJcblx0XHR0aXRsZTogJ0JyYW5jaGVzJyxcclxuXHRcdHZpZXc6ICdCcmFuY2hlcycsXHJcblx0XHRwdWJsaWM6IHRydWUsXHJcblx0XHRsb2NhbGVzOiB7XHJcblx0XHRcdGF6OiAnL2F6L2JyYW5jaGVzJyxcclxuXHRcdFx0ZW46ICcvZW4vYnJhbmNoZXMnLFxyXG5cdFx0XHRydTogJy9ydS9icmFuY2hlcycsXHJcblx0XHR9XHJcblx0fSxcclxuXHQnL2F6L2JyYW5jaGVzJzoge3JlZjogJy9icmFuY2hlcycsIGxhbmc6ICdheicsIHRpdGxlOiAnQnJhbmNoZXMnfSxcclxuXHQnL2VuL2JyYW5jaGVzJzoge3JlZjogJy9icmFuY2hlcycsIGxhbmc6ICdlbicsIHRpdGxlOiAnQnJhbmNoZXMnfSxcclxuXHQnL3J1L2JyYW5jaGVzJzoge3JlZjogJy9icmFuY2hlcycsIGxhbmc6ICdydScsIHRpdGxlOiAnQnJhbmNoZXMnfSwqL1xyXG59XHJcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O29DQUFlO0VBQ2Q7QUFDRDtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFaQyxDQWFBIn0=